<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="授权"
        :close-on-press-escape="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" label-width="120px" class="pr40">
                <el-form-item label="" label-width="75px" style="margin-bottom: 10px;">
                    <p class="text-color-gray font12px">Tips：授权其他成员查看该成员的工单数据，包含所有工单与素材</p>

                </el-form-item>
                <el-form-item label="工单授权：" prop="user_ids">
                    <!--<div class="inline-block" slot="label">-->
                        <!--<el-tooltip class="item" effect="dark" content="授权其他成员查看该成员的工单数据，包含所有工单与素材" placement="top-start">-->
                            <!--<span> <i class="el-icon-question"></i> 工单授权：</span>-->
                        <!--</el-tooltip>-->
                   <!--</div>-->
                    <ESelect v-model="formItem.user_ids" multiple filterable class="full-w"
                               placeholder="请选择授权人">
                        <el-option
                            v-for="item in userList"
                            :disabled="item.disabled"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </ESelect>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/department.js';
    import utils from '@/libs/utils.js'

    export default {
        name: "MemberAuth",
        components: {},
        props: {
            user:{
                required: true,
                type:Object,
            }
        },
        data() {
            return {
                dialogVisible: false,
                submitLoading: false,
                formItem: {
                    user_ids: [],
                },
                // rules: {
                //     user_ids: [
                //         {type: 'array', required: true, message: '请选择授权人', trigger: 'change'},
                //         {type: 'array', max: 5, message: '最多可选择5个', trigger: 'change'}
                //     ]
                // },
                userList: [],

            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.userList = [];
                this.resetForm();
            },
            resetForm() {
                this.formItem.user_ids = [];
                this.userList = [];
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.getUserList();
                })
            },
            getUserList() {
                API.getAuthUserList({
                    id:this.user.id,
                }).then(res => {
                    let resData = res.data||[];
                    this.userList =resData;
                    this.formItem.user_ids = resData.filter(item=>item.checked).map(item=>item.id);
                }, (err) => {
                    console.log('getUserList error', err);
                    this.userList = [];
                });
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        // userAuth
                        this.submitLoading = true;
                        API.userAuth({
                            id:this.user.id,
                            user_ids:this.formItem.user_ids,
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.dialogVisible = false;
                            this.submitLoading= false;
                            this.$emit('update');
                            this.resetForm();
                        }, (err) => {
                            console.log('userAuth error', err);
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });

                    } else {
                        return false;
                    }
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }

</style>
